import { InfoCircleOutlined } from "@ant-design/icons";
import { Input, Tooltip, type FormInstance } from "antd";
import isNil from "lodash/isNil";

import { RVFormFloatingLabelWrap, RVFormCheckbox, getColor, RVFormItem } from "@regal-voice/ui";

import { VariantsFormItems } from "./VariantsFormItem/VariantsFormItems";

import styles from "./ABTestFormItems.module.scss";

export function ABTestFormItems({
    form,
    formValues = {},
    setCanSubmit,
}: {
    form: FormInstance;
    formValues: Record<string, any>;
    setCanSubmit: (b: boolean) => void;
}): JSX.Element {
    const { disableTriggerExperiment } = formValues;
    const toolTipTitle = (
        <span>
            Check box to turn off experiment tracking.&nbsp;
            {/* @todo Replace with RVLearnMoreLink */}
            <a
                href="https://support.regal.ai/hc/en-us/articles/5724713528219-How-to-Run-an-A-B-Test-in-a-Journey"
                target="_blank"
                rel="noreferrer"
                className={styles.actionLink}
            >
                Learn more
            </a>
        </span>
    );

    return (
        <>
            <RVFormFloatingLabelWrap
                name="testName"
                label="Name of Test"
                showFormLabel={true}
                placeholder="Name"
                rules={[{ required: true, message: "Name is required." }]}
                initialValue={formValues?.testName}
            >
                <Input />
            </RVFormFloatingLabelWrap>
            <RVFormItem name="variants" label="Variants">
                <VariantsFormItems form={form} formValues={formValues} setCanSubmit={setCanSubmit} />
            </RVFormItem>
            <RVFormCheckbox
                name="disableTriggerExperiment"
                initialValue={isNil(disableTriggerExperiment) ? false : disableTriggerExperiment}
            >
                Do Not Trigger Experiment Assigned Event
                <Tooltip title={toolTipTitle} placement="bottomRight" color={getColor("purple5")}>
                    <InfoCircleOutlined className={styles.infoIcon} />
                </Tooltip>
            </RVFormCheckbox>
        </>
    );
}
